import { useState } from 'react';
import ArrowSVG, { Rotate } from '@components/ArrowSVG';
import { PaymentDetail } from '@/state/slice/transactionDetailSlice';
import { CURRENCY } from '@constants/common.constants';
import { getFullDateTime12H } from '@helpers/date-time.helper';

interface BillingRefundCardProps {
	amount?: number;
	billingTransactions?: Partial<PaymentDetail>[];
	currency?: CURRENCY;
	date?: string;
	referenceId: string | undefined;
}

export default function BillingRefundCard({ date = '', amount = 0, billingTransactions = [], currency = CURRENCY.SGD, referenceId }: BillingRefundCardProps) {
	const [isShowBillingDetail, setIsShowBillingDetail] = useState(false);

	return (
		<div className='rounded-lg bg-white border border-blue-grey-lighter w-full tablet:w-[584px] desktop:w-[584px]'>
			<div className='px-4 py-2 bg-blue-grey rounded-t-lg'>
				<h3 className='font-semibold text-white flex justify-center'>{getFullDateTime12H(date)}</h3>
			</div>
			<div className='px-4'>
				<div className={`py-4 items-start ${isShowBillingDetail && 'border-b border-blue-grey-lighter'}`}>
					<div className='flex'>
						<div className='flex flex-wrap flex-col items-center'>
							<span className='text-blue-grey font-semibold'>Billing amount</span>
						</div>
					</div>
					<div className='flex flex-row justify-end gap-2'>
						<div className='flex flex-col items-end'>
							<span className='font-semibold text-[26px] leading-9 text-blue-grey-darkest'>{Number(amount).toFixed(2)}</span>
							<span className='text-blue-grey'>{currency}</span>
						</div>
						<span onClick={() => setIsShowBillingDetail(!isShowBillingDetail)}>
							<ArrowSVG fill='#24A9DF' rotate={isShowBillingDetail ? Rotate.TOP : Rotate.BOTTOM} />
						</span>
					</div>
				</div>
			</div>
			<div className='divide-y px-4 divide-dashed divide-blue-grey-lighter'>
				{isShowBillingDetail &&
					billingTransactions.length > 0 &&
					billingTransactions.map((billing, id) => (
						<div key={id} className='flex justify-between py-4'>
							<div className='text-blue-grey-darkest'>{billing.title}</div>
							<div>
								<p className='font-semibold text-xl'>{Number(billing.amountEntered).toFixed(2)}</p>
								<p className='text-blue-grey float-right'>{currency}</p>
							</div>
						</div>
					))}
			</div>
			<div className='items-start px-4 py-4 border-t border-blue-grey-lighter'>
				<div className='flex'>
					<div className='flex flex-wrap flex-col items-center'>
						<span className='text-blue-grey font-semibold'>Reference ID</span>
					</div>
				</div>
				<div className='flex'>
					<span className='text-blue-grey-darkest pt-2'>{referenceId}</span>
				</div>
			</div>
		</div>
	);
}
